import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from 'src/app/store/session/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionQuery } from 'src/app/store/session/session.query';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  animations: [SharedAnimations]
})
export class ForgotPasswordComponent implements OnInit {
  statusUser: string = null;
  showError = false;
  showSuccess = false;
  messageError = '';
  loading$: Observable<boolean>;
  loadingText: string;
  form: FormGroup;
  textError = '';
  cellPhone: string;
  sentSMS: boolean;

  constructor(
    private fb: FormBuilder,
    private sessionService: SessionService,
    private sessionQuery: SessionQuery,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.loading$ = this.sessionQuery.selectLoading();
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.route.queryParams.subscribe(params => {
      const email = params['email'] ?? '';
      this.form.setValue({ email: email });
    })

  }

  forgotPassword(values) {
    this.showError = false;
    this.loadingText = 'Aguarde...';
    this.sessionService.forgotPassword(values.email).subscribe((response: any) => {
      if (response.success) {
        this.showSuccess = true;
        this.cellPhone = response.cellPhone;
      } else {
        this.showError = true;
        this.messageError = 'Não foi possível recuperar sua senha. Tente novamente mais tarde';
      }
    }, err => {
      this.showError = true;
      this.messageError = 'Falha ao recuperar sua senha. Tente novamente mais tarde.';
    });

  }

  closeAlert() {
    this.showError = false;
  }

  sendSMS(): void {
    this.sentSMS = true;
    this.sessionService.sendSMS(this.form.get('email').value)
      .subscribe(resp => resp);
  }
}
